import React from 'react';
import { Modal, PercentBar } from '../../components';

const ModalAllCategories=({
  isOpen,
  categories=[],
  onCancel,
})=>{

  let bars;
  if(categories.length) {
    bars=categories.map((elem,index)=>{
      const {category,fit}=elem;
      return <PercentBar key={'percent_bar_'+index} name={category} percent={fit} />
    });
  }

  return (
    <Modal isOpen={isOpen} onClose={onCancel} className="modal-content-default template-alert-modal">
      <div className="font-color2">
        {bars}
        <div className="modal-controls">
          <button onClick={onCancel} className="btn btn-default1" type="button">Ok</button>
        </div>
      </div>
    </Modal>
  )
}

export default ModalAllCategories;